export default __webpack_public_path__ + "static/media/minimized-arrows.f9b10c9b.svg";